import {
  ACCESS_ROLES_ICONS,
  ACCESS_SELECT_ITEMS,
} from 'pages/ApiClients/constants/accessSelectItems';
import { Chip } from 'shared/mui/Chips';
import { ListField } from 'shared/react-admin/Fields';

type Props = {
  label?: string;
};

export const ApiClientsAccessField: React.FC<Props> = ({ label = 'Доступ' }) => (
  <ListField
    array={ACCESS_SELECT_ITEMS}
    label={label}
    renderItem={({ id, label }) => <Chip icon={ACCESS_ROLES_ICONS[id]} key={id} label={label} />}
    sortable={false}
    source="roles"
  />
);
